import { Hydrate as RqHydrate } from 'react-query/hydration';
export const Hydrate = RqHydrate;
//# sourceMappingURL=Hydrate.js.map